import createDocumentResource from 'src/actions/shared/createDocumentResource';

export class AgentExperienceConfig {
  allowExternalName: boolean;
}

const agentExperienceConfigResource = createDocumentResource<AgentExperienceConfig>({
  name: 'agentExperienceConfig',
  endpoint: 'v1/orgs/:orgId/configuration/agent-experience',
  type: AgentExperienceConfig,
});
export default agentExperienceConfigResource;
